"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _capitalize = _interopRequireDefault(require("lodash/capitalize"));

var _warning = _interopRequireDefault(require("warning"));

var _excluded = ["classes", "className", "component", "primary", "secondary", "variant", "align", "underlined", "gutterBottom"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return _objectSpread(_objectSpread({
    root: {
      margin: 0,
      width: '100%'
    },
    gutterBottom: {
      marginBottom: '1rem'
    }
  }, theme.typography), {}, {
    alignLeft: {
      textAlign: 'left'
    },
    alignCenter: {
      textAlign: 'center'
    },
    alignRight: {
      textAlign: 'right'
    },
    alignJustify: {
      textAlign: 'justify'
    }
  });
};

var componentMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  body1: 'p',
  body2: 'p'
};
var alignmentMapping = {
  h1: 'center',
  h2: 'center'
};

var Typography = function Typography(props) {
  var _clsx;

  var _props$classes = props.classes,
      classes = _props$classes === void 0 ? {} : _props$classes,
      className = props.className,
      component = props.component,
      primary = props.primary,
      secondary = props.secondary,
      variant = props.variant,
      align = props.align,
      underlined = props.underlined,
      gutterBottom = props.gutterBottom,
      rest = _objectWithoutProperties(props, _excluded);

  (0, _warning["default"])(!(primary && secondary), 'A component cannot be primary and secondary at the same time!');
  var alignment = align || alignmentMapping[variant] || 'inherit';
  var Component = component || componentMapping[variant] || 'span';
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: (0, _clsx2["default"])(classes.root, (_clsx = {}, _defineProperty(_clsx, classes[variant], true), _defineProperty(_clsx, classes["align".concat((0, _capitalize["default"])(alignment))], true), _defineProperty(_clsx, classes["".concat(variant, "Primary")], primary), _defineProperty(_clsx, classes["".concat(variant, "Secondary")], secondary), _defineProperty(_clsx, classes.gutterBottom, gutterBottom), _defineProperty(_clsx, classes.linkUnderlined, variant === 'link' && underlined), _clsx), className)
  }, rest));
};

Typography.defaultProps = {
  classes: {},
  variant: 'body1',
  primary: false,
  secondary: false
};
Typography.propTypes = {
  children: _propTypes["default"].any,
  classes: _propTypes["default"].any,
  className: _propTypes["default"].string,
  primary: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  underlined: _propTypes["default"].bool,
  gutterBottom: _propTypes["default"].bool,
  align: _propTypes["default"].oneOf(['left', 'center', 'justify', 'right']),
  component: _propTypes["default"].oneOf(['div', 'p', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  variant: _propTypes["default"].oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'form1', 'form2', 'button1', 'button2', 'caption', 'link', 'callout'])
};

var _default = (0, _reactJss["default"])(styles)(Typography);

exports["default"] = _default;